<template>
  <div class="m-edition-billing-academy-migration-sale-info">
    <div v-if="loading">
      <p class="text-align-center">Cargando datos ...</p>
    </div>
    <div v-else-if="Object.keys(venta).length === 0">
      <p class="text-align-center">No hay datos disponibles.</p>
    </div>
    <div v-else>
      <div>
        <h4 class="info-title">DETALLE DE VENTA</h4>
        <p>
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-history"></i>
          </span>
          <span>
            Venta
            <span :class="[$filters.getSaleStateValue(venta.venta.venta.venta_estado, 'class'), 'font-weight-bold']">
              {{ $filters.getSaleStateValue(venta.venta.venta.venta_estado, 'name') }}
            </span>
              desde
              <span class="text-transform-capitalize">
                {{ $moment.parseZone(venta.venta.venta.fecha_venta).format('D MMMM, YYYY') }}
              </span>
          </span>
        </p>
        <p v-if="venta.venta.suscripcion && venta.venta.suscripcion.fecha_cancelar_venta">
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-calendar-day"></i>
          </span>
          <span>
            El cliente tendrá acceso hasta el día
            <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
              {{ $moment.parseZone(venta.venta.suscripcion.fecha_cancelar_venta).format('D MMMM, YYYY') }}
            </span>
          </span>
        </p>
        <p>
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-receipt"></i>
          </span>
          <span>
            {{ venta.venta.venta.concepto_venta }}
          </span>
        </p>
        <p v-if="venta.venta.venta.id_plan">
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-dollar-sign"></i>
          </span>
          <span v-if="venta.venta.suscripcion">
            Monto total de {{ venta.venta.suscripcion.divisa }}
            <span class="font-weight-bold">
              {{ getTotalVenta(venta.venta.venta.total, venta.venta.venta.precio,
                venta.venta.venta.trial_precio, venta.venta.suscripcion.pago_cuotas).toFixed(2) }}
            </span>
            <span class="text-color-black-35">
              {{ venta.venta.suscripcion.divisa_iso_code }}
            </span>
          </span>
          <span v-else>
            Monto total de  {{ venta.venta.venta.divisa }}
            <span class="font-weight-bold">
              {{ getTotalVenta(venta.venta.venta.total, venta.venta.venta.precio,
                venta.venta.venta.trial_precio, venta.venta.venta.pago_cuotas).toFixed(2) }}
            </span>
            <span class="text-color-black-35">
              {{ venta.venta.venta.divisa_iso_code }}
            </span>
          </span>
        </p>
        <p v-else>
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-dollar-sign"></i>
          </span>
          <span class="font-weight-bold">
            Gratis
          </span>
        </p>
        <p v-if="venta.venta.venta.id_plan && venta.venta.venta.precio">
          <span class="info-icon-left info-icon-billing">
            <i class="far fa-credit-card"></i>
          </span>
          <span v-if="venta.venta.suscripcion">
            A pagar en
            <span class="font-weight-bold">
              {{ $utils.getPaymentFrequency(venta.venta.suscripcion.pago_cuotas, venta.venta.suscripcion.pago_frecuencia,
                venta.venta.suscripcion.pago_intervalo) }}
              de
              {{ venta.venta.suscripcion.divisa }}
              {{ venta.venta.suscripcion.precio.toFixed(2) }}
            </span>
              <span class="text-color-black-35">
                {{ venta.venta.suscripcion.divisa_iso_code }}
              </span>
              con {{ venta.venta.suscripcion.medio_pago }}
          </span>
          <span v-else>
            A pagar en
            <span class="font-weight-bold">
              {{ $utils.getPaymentFrequency(venta.venta.venta.pago_cuotas,
                venta.venta.venta.pago_frecuencia, venta.venta.venta.pago_intervalo) }}
              de
              {{ venta.venta.venta.divisa }}
              {{ venta.venta.venta.precio.toFixed(2) }}
            </span>
              <span class="text-color-black-35">
                {{ venta.venta.venta.divisa_iso_code }}
              </span>
              con {{ venta.venta.venta.medio_pago }}
          </span>
        </p>
        <p v-if="venta.venta.venta.trial_precio">
          <span class="info-icon-left info-icon-billing">
            <i class="far fa-clock"></i>
          </span>
          <span>
            Pago por periodo de prueba de
            <span class="font-weight-bold">
              {{ venta.venta.venta.divisa }}
              {{ venta.venta.venta.trial_precio.toFixed(2) }}
            </span>
            <span class="text-color-black-35">
              {{ venta.venta.venta.divisa_iso_code }}
            </span>
            con {{ venta.venta.venta.medio_pago }}
          </span>
        </p>
        <p v-if="venta.venta.venta.trial_intervalo">
          <span class="info-icon-left info-icon-billing">
            <i class="far fa-clock"></i>
          </span>
          <span>
            Periodo de prueba de
            <span class="font-weight-bold">
              {{ venta.venta.venta.trial_intervalo }}
              {{ $filters.getFrequencyValue(venta.venta.venta.trial_frecuencia, 'name') }}
            </span>
          </span>
        </p>
        <p v-if="compensar > 0">
          <span class="info-icon-left info-icon-billing">
            <i class="far fa-usd-circle"></i>
          </span>
          <span>
            Compensación de
            <span class="font-weight-bold">
              {{ compensar }}
              {{ $filters.getFrequencyValue(1, 'name') }}
            </span>
          </span>
        </p>
        <p v-if="venta.venta.venta.detalle && venta.venta.venta.detalle.cuponCodigo">
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-percentage"></i>
          </span>
          <span>
            Se aplicó descuento
            <span class="font-weight-bold">
              {{ venta.venta.venta.detalle.cuponCodigo }}
            </span>
            del
            <span class="font-weight-bold">
              {{ venta.venta.venta.detalle.cuponMontoDescuento }}%
            </span>
          </span>
        </p>
        <p v-if="venta.venta.iva">
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-percentage"></i>
          </span>
          <span>
            Se aplicó impuesto (IVA) del
            <span>
              {{ venta.venta.iva }}%
            </span>
          </span>
        </p>
        <div v-if="venta.venta.suscripcion">
          <p v-if="venta.venta.suscripcion.id_externo">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-key"></i>
            </span>
            <span>
              ID de suscripción en
              <span class="font-weight-bold">
                {{ venta.venta.suscripcion.medio_pago }}
              </span>
              <i class="text-color-black-65">
                {{ venta.venta.suscripcion.id_externo }}
              </i>
            </span>
          </p>
          <p v-if="venta.venta.suscripcion.fecha_inicio &&
            $moment.parseZone().isBefore($moment.parseZone(venta.venta.suscripcion.fecha_inicio))">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              El primer pago será el
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone(venta.venta.suscripcion.fecha_inicio).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p v-else-if="venta.venta.suscripcion.fecha_proximo_pago">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              El próximo pago será el
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone(venta.venta.suscripcion.fecha_proximo_pago).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
        </div>
        <p
          v-if="venta.venta.proyectos && venta.venta.proyectos.length"
          style="align-items:baseline !important;"
        >
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-list"></i>
          </span>
          <ul style="list-style: none; margin: 0; padding: 0;">
            <li style="padding-bottom: 10px">
              <span class="font-weight-bold">
                Los Proyectos incluidos son los siguientes
              </span>
            </li>
            <li
              v-for="(proyecto, index) in venta.venta.proyectos"
              :key="index"
              style="font-style: italic; padding-bottom: 5px;"
            >
              <span>
                - {{ proyecto.titulo}}
              </span>
            </li>
          </ul>
        </p>
      </div>

      <div class="margin-top-xxlarge">
        <h4 class="info-title">CLIENTE</h4>
        <p class="display-block">
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-user"></i>
          </span>
          <span>
            {{ venta.venta.cliente.datos_personales.razon_social }}&nbsp;&bull;&nbsp;{{ venta.venta.cliente.email }}
          </span>
        </p>
        <p class="display-block">
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-id-card"></i>
          </span>
          <span>
            <span v-if="venta.venta.cliente.datos_personales.fisica">
              {{ $filters.getPersonValue(+venta.venta.cliente.datos_personales.fisica, 'name') }}&nbsp;
            </span>
            <span v-if="venta.venta.cliente.datos_personales.fisica &&
              (venta.venta.cliente.datos_personales.documento &&
              (venta.venta.cliente.datos_personales.documento.tipo.id_documento_tipo !== 1 &&
              venta.venta.cliente.datos_personales.documento.tipo.nombre !== 'ID'))"
            >
              &bull;&nbsp;
            </span>
            <span v-if="venta.venta.cliente.datos_personales.documento &&
              venta.venta.cliente.datos_personales.documento.tipo.id_documento_tipo !== 1 &&
              venta.venta.cliente.datos_personales.documento.tipo.nombre !== 'ID' &&
              venta.venta.cliente.datos_personales.documento.numero"
            >
              {{ venta.venta.cliente.datos_personales.documento.tipo.nombre }}
              {{ venta.venta.cliente.datos_personales.documento.numero }}
            </span>
          </span>
        </p>
        <p
          v-if="venta.venta.cliente.datos_personales &&
            venta.venta.cliente.datos_personales.domicilio"
          class="display-block"
        >
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-map-marker-alt"></i>
          </span>
          <span>
            <span>
              {{ venta.venta.cliente.datos_personales.domicilio.provincia.pais.nombre }}
            </span>
            <span>
              , {{ venta.venta.cliente.datos_personales.domicilio.provincia.nombre }}
            </span>
            <span v-if="venta.venta.cliente.datos_personales.domicilio.localidad">
              , {{ venta.venta.cliente.datos_personales.domicilio.localidad }}
            </span>
            <span v-if="venta.venta.cliente.datos_personales.domicilio.codigo_postal">
              , {{ venta.venta.cliente.datos_personales.domicilio.codigo_postal }}
            </span>
            <span v-if="venta.venta.cliente.datos_personales.domicilio.linea1">
              , {{ venta.venta.cliente.datos_personales.domicilio.linea1 }}
            </span>
            <span v-if="venta.venta.cliente.datos_personales.domicilio.linea2">
              {{ venta.venta.cliente.datos_personales.domicilio.linea2 }}
            </span>
          </span>
        </p>
        <p
          v-if="venta.venta.cliente.datos_personales.telefono ||
            venta.venta.cliente.datos_personales.movil"
          class="display-block"
        >
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-mobile-alt"></i>
          </span>
          <span>
            <span v-if="venta.venta.cliente.datos_personales.telefono">
              Teléfono
              {{ venta.venta.cliente.datos_personales.telefono }}
            </span>
            <span v-if="venta.venta.cliente.datos_personales.telefono &&
              venta.venta.cliente.datos_personales.movil"
            >
              &nbsp;&bull;&nbsp;
            </span>
            <span v-if="venta.venta.cliente.datos_personales.movil">
              Móvil
              {{ venta.venta.cliente.datos_personales.movil }}
            </span>
          </span>
        </p>
      </div>

      <div
        v-if="venta.licencia"
        class="margin-top-xxlarge"
      >
        <h4 class="info-title">LICENCIA</h4>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-users"></i>
            </span>
            <span>Alumnos</span>
            <span class="font-size-xsmall text-color-black-45">
              ({{ venta.recursos.alumnos }} de {{ venta.recursos.maximo_alumnos }} en uso)
            </span>
          </span>
          <span class="info-text-right">
            {{ this.getPorcentaje(venta.recursos.alumnos,venta.recursos.maximo_alumnos) }}%
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-folder-open"></i>
            </span>
            <span>Proyectos</span>
            <span class="font-size-xsmall text-color-black-45">
              (ilimitado)
            </span>
          </span>
          <span class="info-text-right">
            <i class="far fa-infinity"></i>
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-map-marker-alt"></i>
            </span>
            <span>Mapas de Aprendizaje</span>
            <span class="font-size-xsmall text-color-black-45">
              (ilimitado)
            </span>
          </span>
          <span class="info-text-right">
            <i class="far fa-infinity"></i>
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-box-open"></i>
            </span>
            <span>Productos</span>
            <span class="font-size-xsmall text-color-black-45">
              (ilimitado)
            </span>
          </span>
          <span class="info-text-right">
            <i class="far fa-infinity"></i>
          </span>
        </p>
        <p v-if="false">
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-envelope"></i>
            </span>
            <span>Listas de e-mail</span>
            <span class="font-size-xsmall text-color-black-45">
              (0 de {{ venta.recursos.maximo_emails }} en uso)
            </span>
          </span>
          <span class="info-text-right">
            {{ this.getPorcentaje(0,venta.recursos.maximo_emails) }}%
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-file-invoice"></i>
            </span>
            <span>Puntos de Venta</span>
            <span class="font-size-xsmall text-color-black-45">
              (ilimitado)
            </span>
          </span>
          <span class="info-text-right">
            <i class="far fa-infinity"></i>
          </span>
        </p>
        <p v-if="false">
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-percent"></i>
            </span>
            <span>Comisiones</span>
          </span>
          <span class="info-text-right">
            {{ venta.licencia.comisiones }}%
          </span>
        </p>
        <p v-if="false">
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-percent"></i>
            </span>
            <span>Sin Comisiones</span>
          </span>
          <span class="info-icon-right info-icon-billing margin-left-auto">
            <i class="fas fa-check"></i>
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-graduation-cap"></i>
            </span>
            <span>Profesional Universidad</span>
          </span>
          <span
            v-if="venta.licencia.tipo_universidad"
            class="info-icon-right info-icon-billing margin-left-auto"
          >
            <i class="fas fa-check"></i>
          </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
            No
          </span>
        </p>
        <p>
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-walkie-talkie"></i>
            </span>
            <span>Integraciones</span>
          </span>
          <span
            v-if="venta.licencia.integraciones"
            class="info-icon-right info-icon-billing margin-left-auto"
          >
            <i class="fas fa-check"></i>
          </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
            No
          </span>
        </p>
        <p v-if="false">
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-video"></i>
            </span>
            <span>Clases en vivo por Zoom</span>
          </span>
          <span
            v-if="venta.licencia.clases_vivo"
            class="info-icon-right info-icon-billing margin-left-auto"
          >
            <i class="fas fa-check"></i>
          </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
            No
          </span>
        </p>
        <p v-if="false">
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-hands-helping"></i>
            </span>
            <span>Afiliaciones</span>
          </span>
          <span
            v-if="venta.licencia.afiliaciones"
            class="info-icon-right info-icon-billing margin-left-auto"
          >
            <i class="fas fa-check"></i>
          </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
            No
          </span>
        </p>
        <p v-if="false">
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-ballot-check"></i>
            </span>
            <span>Evaluaciones</span>
          </span>
          <span
            v-if="venta.licencia.evaluaciones"
            class="info-icon-right info-icon-billing margin-left-auto"
          >
            <i class="fas fa-check"></i>
          </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
            No
          </span>
        </p>
        <p v-if="false">
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-user-check"></i>
            </span>
            <span>Control de alumnos</span>
          </span>
          <span
            v-if="venta.licencia.control_alumnos"
            class="info-icon-right info-icon-billing margin-left-auto"
          >
            <i class="fas fa-check"></i>
          </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
            No
          </span>
        </p>
        <p v-if="false">
          <span class="info-text-left">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-file-import"></i>
            </span>
            <span>Importación de alumnos</span>
          </span>
          <span
            v-if="venta.licencia.importacion_alumnos"
            class="info-icon-right info-icon-billing margin-left-auto"
          >
            <i class="fas fa-check"></i>
          </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
            No
          </span>
        </p>
        <p
          v-if="academyDomain.length"
          class="display-block"
        >
          <span class="info-icon-left info-icon-billing">
            <i class="fas fa-link"></i>
          </span>
          <a :href="academyDomain" target="_blank" class="font-weight-bold text-link-hover-billing">
            {{ academyDomain }}
          </a>
        </p>
        <p
          v-else
          class="display-block"
        >
          <span class="info-icon-left info-icon-assets">
            <i class="fas fa-times"></i>
          </span>
          <span class="font-weight-bold text-color-assets-primary">
            No existe una academia relacionada a la licencia.
          </span>
        </p>
      </div>
      <div v-else>
        <p>
          <span class="info-icon-left info-icon-assets">
            <i class="fas fa-times"></i>
          </span>
          <span class="font-weight-bold text-color-assets-primary">
            No existe una licencia relacionada a la venta.
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import configApp from '@/config'

export default {
  name: 'MoleculeEditionBillingAcademyMigrationSaleInfo',

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    venta: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      academyDomain: '',
      trialPago: false
    }
  },

  computed: {
    compensar () {
      return this.venta.venta.suscripcion && this.venta.venta.suscripcion.fecha_inicio &&
        this.$moment.parseZone().isBefore(this.$moment.parseZone(this.venta.venta.suscripcion.fecha_inicio))
        ? this.$moment.parseZone(this.venta.venta.suscripcion.fecha_inicio).set({
          hour: 0, minute: 0, second: 0, millisecond: 0 }).diff(this.$moment.parseZone(this.venta.venta.suscripcion.fecha_creacion).set({
          hours: 0, minutes: 0, seconds: 0 }), 'days')
        : null
    }
  },

  watch: {
    venta () {
      this.academyDomain = this.venta.academia && this.venta.academia.url
        ? `${configApp.marketPlaceDomain}/${this.venta.academia.url}`
        : ''
    }
  },

  methods: {
    getPorcentaje (valor, maximo) {
      return parseInt((valor * 100) / maximo)
    },

    getTotalVenta (total = 0, monto, trial, cuotas) {
      return !cuotas
        ? total
        : this.trialPago
          ? (cuotas * monto) + trial
          : (cuotas * monto)
    }
  }
}
</script>
